export default __webpack_public_path__ + "static/media/noRace.e7b9f679.png";